<p>carrier-selection-dialog works!</p>